/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

/**
 * @description A custom field value, or an array of them for multi-value fields.
 */
export const projectedCustomFieldValueSchema = z
  .object({
    description: z.string().nullish(),
    value: z.union([z.boolean(), z.string(), z.number()]).nullish(),
  })
  .describe('A custom field value, or an array of them for multi-value fields.');
